// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://voysdmpwjmrvndxjeerc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZveXNkbXB3am1ydm5keGplZXJjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYxNzAwMjIsImV4cCI6MjA1MTc0NjAyMn0.oIZijoxIMsI4gkqy5NvwK23BBiRsAmn-NzYt0r441ho";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);